export const BASENAME = ""; // don't add '/' at end off BASENAME
export const BASE_URL = "/pin";
export const BASE_TITLE = " | Timesheet ClockIn ";
export const API_SERVER = process.env.REACT_APP_BASE_URL || "http://localhost:4000/api/";

export const CONFIG = {
  layout: "vertical",
  subLayout: "",
  collapseMenu: false, // mini-menu
  layoutType: "menu-dark",
  navIconColor: false,
  headerBackColor: "header-default",
  navBackColor: "navbar-default",
  navBrandColor: "brand-default",
  navBackImage: false,
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: false,
  boxLayout: false,
  navDropdownIcon: "style1",
  navListIcon: "style1",
  navActiveListColor: "active-default",
  navListTitleColor: "title-default",
  navListTitleHide: false,
  configBlock: true,
  layout6Background:
    "linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)",
  layout6BackSize: "",
};
